var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F3F2EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1087_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.91016 15.2433C5.91016 14.9913 5.70622 14.7871 5.45443 14.7871C5.20264 14.7871 4.9987 14.9913 4.9987 15.2433V18.5221C4.9987 18.7741 5.20264 18.9783 5.45443 18.9783H8.78353C9.03532 18.9783 9.23926 18.7741 9.23926 18.5221C9.23926 18.27 9.03532 18.0659 8.78353 18.0659H6.59831L10.513 14.3618C10.6953 14.1896 10.7044 13.9022 10.5324 13.7186C10.3604 13.5361 10.0732 13.527 9.88981 13.6992L5.91016 17.4649V15.2433ZM8.76644 5.91113C9.01823 5.91113 9.22217 5.70699 9.22217 5.45495C9.22217 5.20292 9.01823 4.99878 8.76644 4.99878H5.49088C5.23909 4.99878 5.03516 5.20292 5.03516 5.45495V8.78617C5.03516 9.03821 5.23909 9.24234 5.49088 9.24234C5.74267 9.24234 5.94661 9.03821 5.94661 8.78617V6.59995L9.64713 10.5185C9.81917 10.701 10.1063 10.7101 10.2897 10.5379C10.472 10.3657 10.4811 10.0783 10.3091 9.89467L6.54704 5.91113H8.76644ZM18.0895 8.73599C18.0895 8.98803 18.2935 9.19216 18.5452 9.19216C18.797 9.19216 19.001 8.98803 19.001 8.73599V5.45723C19.001 5.2052 18.797 5.00106 18.5452 5.00106H15.2173C14.9655 5.00106 14.7616 5.2052 14.7616 5.45723C14.7616 5.70927 14.9655 5.91341 15.2173 5.91341H17.4014L13.4867 9.61755C13.3044 9.78975 13.2952 10.0771 13.4673 10.2608C13.6393 10.4432 13.9264 10.4523 14.1099 10.2801L18.0895 6.51442V8.73599ZM15.2469 18.0887C14.9951 18.0887 14.7912 18.2928 14.7912 18.5449C14.7912 18.7969 14.9951 19.0011 15.2469 19.0011H18.5225C18.7743 19.0011 18.9782 18.7969 18.9782 18.5449V15.2125C18.9782 14.9605 18.7743 14.7564 18.5225 14.7564C18.2707 14.7564 18.0667 14.9605 18.0667 15.2125V17.3999L14.3662 13.4813C14.1942 13.2989 13.9071 13.2898 13.7236 13.462C13.5413 13.6342 13.5322 13.9216 13.7043 14.1052L17.4663 18.0887H15.2469Z",
    fill: "#B99750"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1087_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "matrix(-1 0 0 1 19 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentFullscreen);
export default __webpack_public_path__ + "static/media/comment_fullscreen.a4c34f045f5eceee4964db9b0ec1d393.svg";
export { ForwardRef as ReactComponent };